import script from "./RetornosRenovacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./RetornosRenovacoes.vue?vue&type=script&setup=true&lang=js"

import "./RetornosRenovacoes.vue?vue&type=style&index=0&id=9c73392c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c73392c"]])

export default __exports__